import { useMemo } from 'react'
import * as React from 'react'
import LayoutContainer from 'components/Common/LayoutContainer'
import Pane from 'components/Common/Pane'
import OfferListCarousel from 'components/OfferList/OfferListCarousel'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import { mediaQueryUp } from 'components/utils/breakpoint'
import Sheet from 'components/utils/Sheet'
import { OptimizelyFeatureFlags } from 'constants/optimizely'
import useFeatureFlag from 'hooks/Optimizely/useFeatureFlag'
import useLereRankedOfferList from 'hooks/Offers/useLereRankedOfferList'
import { rem } from 'polished'
import styled from 'styled-components'
import TriplePointTakeoverBackground from './TriplePointTakeoverBackground'
import TriplePointTakeoverLogo from './TriplePointTakeoverLogo'
import societyTriplePointsTakeoverConfig, { triplePointCampaignId } from 'takeovers/societyTriplePointsTakeover/societyTriplePointsTakeoverConfig'
import TriplePointTakeoverCampaignHeader from './TriplePointTakeoverCampaignHeader'

const SiteTakeoverBackground = styled.div`
  position: absolute;
  inset: 0;
  width: 100%;
`

const CarouselContainer = styled(Pane)`
  position: relative;
  padding-top: ${rem(40)};
  padding-bottom: ${rem(40)};

  ${mediaQueryUp.desktop} {
    /**
     * This adds room for the search section on all homepages
     */
    padding-bottom: ${rem(100)};

  }
`

const Content = styled(VerticalSpacer)`
  position: relative;
  z-index: 1;
`

interface Props {
  className?: string
  viewOffersTo?: string
}

function TriplePointTakeoverHeroCarousel(props: Props) {
  const { className, viewOffersTo } = props
  const lereHeroCarouselEnabled = useFeatureFlag(OptimizelyFeatureFlags.lereHeroCarouselEnabled)

  const filters = useMemo<App.OfferListFilters>(() => {
    return {
      offerTypes: ['hotel', 'tactical_ao_hotel', 'tour_v2', 'cruise'],
      limit: 20,
      campaigns: [triplePointCampaignId],
      sortBy: 'triple-points',
    }
  }, [])
  const shouldRankOfferList = lereHeroCarouselEnabled &&
    societyTriplePointsTakeoverConfig.heroSection?.offerListRanking === 'lere-ranker'
  const rankedOfferList = useLereRankedOfferList(filters, {
    disabled: !shouldRankOfferList,
  })

  return (
    <CarouselContainer
      background="normal-background"
      className={className}
    >
      <SiteTakeoverBackground>
        <TriplePointTakeoverBackground />
      </SiteTakeoverBackground>
      <Content gap={24}>
        <LayoutContainer>
          <TriplePointTakeoverCampaignHeader
            logo={<TriplePointTakeoverLogo size="medium" />}
            titleVariant="heading2"
            viewOffersTo={viewOffersTo}
          />
        </LayoutContainer>
        <Sheet paletteType="default">
          <OfferListCarousel
            filters={filters}
            overrideOfferList={shouldRankOfferList ? rankedOfferList : undefined}
            tileStyle="card-opaque"
            tileSize="medium"
          />
        </Sheet>
      </Content>
    </CarouselContainer>
  )
}

export default React.memo(TriplePointTakeoverHeroCarousel)
